// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3oDXx","header":"Messages_header__2WGhe"};